import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const calendarDateFormatter = new Intl.DateTimeFormat('fr-BE', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
});

export function formatCalendarDateRange(date: string, dateEnd?: string) {
  const format = (value: string) => calendarDateFormatter.format(new Date(`${value}T00:00:00Z`));

  const start = format(date);
  return dateEnd ? `${start} au ${format(dateEnd)}` : start;
}
